export const KEYS = {
    UAT: {
        KEY: 'U2FsdGVkX1+DOwV34q4SwOId+03wRvSi9tSYa0Skk/zEup46zMh83N+T6nhH4HNKbb0WOuzoLno6z35PVJlEYKTWzTPCXQBhGqynEdEvLFuRuRuEN5MNz6SP1cI4EjZv',
        BASE_URL_BACKOFFICE: 'https://uatclientes.firmaautografa.com/login?tfmasdivo='
    },
    PROD: {
        KEY: 'U2FsdGVkX18SWqzfCev/TcxppWstzLDIA16bSof1OZ2fjWXwjbh0qQ/jRQLm7iw+xVW4aHNb3YfDLgd01mJBKXGOJk2+EcKivxSS/pxo2VvE4NykONHrID/d0smFU4Vk',
        BASE_URL_BACKOFFICE: 'https://clientes.firmaautografa.com/login?tfmasdivo='
    }
};
